<template>
  <div class="bg">
    <div class="img-content">
      <img class="chap" src="@/assets/images/chap.png" alt="" />

      <div class="tle">
        {{
          merchant_name ? merchant_name + "区块链数字证书" : "区块链数字证书"
        }}
      </div>

      <div style="color: #808080" class="fz14 mar">
        <div
          style="display: flex; align-items: center"
          class="mb14"
          v-for="(item, index) in syList"
          :key="index"
        >
          <div style="white-space: nowrap">{{ item.title }}：</div>
          <div style="word-break: break-all">{{ item.example }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
export default {
  data() {
    return {
      listObj: {},
      picList: [],
      spObj: {},
      listDataAll: [],
      list: [],
      mList: [],
      materialData: [],
      maList: [],
      mList2: {},
      info: [],
      infoList: [],
      newArr: [],
      newArr2: [],
      show: false,
      ts: "",
      txid: "",
      pyList: [],
      pyInfo: {},
      merchant_name: "",
      certificate_chain_id: "",
      syList: [],
    };
  },
  //生命周期 - 创建完成（访问当前this实例）
  created() {
    this.certificate_chain_id = JSON.parse(
      localStorage.getItem("reData")
    ).certificate_chain_id;
    console.log(this.certificate_chain_id, "certificate_chain_id");

    this.listDataAll = JSON.parse(window.localStorage.getItem("defalutObj"));
    this.merchant_name = localStorage.getItem("merchant_name");
    this.list = this.listDataAll.filter(
      (item) => item.trace_name === "溯源证书"
    );

    this.list.forEach((item) => {
      this.list = item.msgItems;
    });
    console.log(this.list, "list");
    this.txid = this.list[0].txid;
    this.syList = this.list[0].op.op;
  },
  //生命周期 - 挂载完成（访问DOM元素）
  mounted() {},
  //方法
  methods: {},
};
</script>
  <style lang="scss" scoped>
.mar {
  margin: -20px 50px 0;
}
.w200 {
  width: 420px;
}
.w100 {
  width: 200px;
}
.mb14 {
  margin-bottom: 20px;
}
.fz14 {
  font-size: 28px;
}
.bg {
  width: 686px;
  height: 1212px;
  background: url("~@/assets/images/certificate.png");
  background-size: 686px 1212px;
  background-repeat: no-repeat;
  //   box-shadow: 0px 6px 20px rgba(0, 0, 0, 0.16);
  border-radius: 8px;
  margin-bottom: 32px;
  background-color: #fff;
  .img-content {
    border: 1px solid #ccc;
    width: 686px;
    height: 1212px;
    position: relative;
    .chap {
      position: absolute;
      top: 72%;
      right: 80px;
      width: 200px;
      height: 200px;
    }
    .tle {
      margin: 100px 0 60px;
      font-size: 44px;
      font-family: PingFang SC;
      font-weight: bold;
      line-height: 56px;
      color: #cc833e;
      text-align: center;
    }
    .item {
      // margin: 0 0 54px 60px;
      margin: 0 60px 54px;
      font-size: 24px;
      font-family: PingFang SC;
      line-height: 24px;
      color: #808080;
      div {
        &:last-child {
          margin-top: 10px;
          font-size: 28px;
          text-align: center;
          font-family: PingFang SC;
          line-height: 40px;
          color: #222222;
          background: #f5f5f5;
          border-radius: 8px;
          padding: 16px 12px;
          word-break: break-all;
        }
      }
    }
    .footer {
      margin-bottom: 16px;
      width: 526px;
      display: flex;
      justify-content: space-between;
      font-size: 10px;
    }
  }
}
</style>
  